import type { Components } from '@mui/material/styles';

export default function MuiMenu(): Components['MuiMenu'] {
  return {
    defaultProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
    },
  };
}
